import api from "@/api";
import ObjectUtils from "@/modules/Object/ObjectUtils";
import TimerUtils from "@/modules/Timer/TimerUtils";
import { PaymentRequirementsHistoryItem, PaymentRequirementsHistoryParams } from "./payment-requirements-history.interface";

export const $getPaymentRequirementsHistory = async (
	body: PaymentRequirementsHistoryParams
): Promise<PaymentRequirementsHistoryItem[]> => {
	// await TimerUtils.sleep(600);

	return api
		.post(
			'payment-requirements/get-history',
			ObjectUtils.excludeValues(body, [ null ]),
			{ handler: { disableLoader: true } }
		)
		.then(response => response || []);
};